import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import { Communication_Code } from '~/graphql/types'

@Module({
  name: 'communication-codes',
  stateFactory: true,
  namespaced: true,
})
export default class CommunicationCodes extends VuexModule {
  fetchStarted = false
  loading = true
  items: Communication_Code[] = []

  @Mutation
  setFetchStarted(fetchStarted) {
    this.fetchStarted = fetchStarted
  }

  @Mutation
  setLoading(loading) {
    this.loading = loading
  }

  @Mutation
  setItems(items) {
    this.items = items
  }
}
